module.exports = __webpack_public_path__ + "img/texiao-_0000s_0019_20.2c381cfe.png";